import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface TypewriterTextProps {
  text: string;
  speed?: number;
  className?: string;
  showCursor?: boolean;
  onComplete?: () => void;
  onStart?: () => void;
}

export function TypewriterText({
  text,
  speed = 12,
  className,
  showCursor = true,
  onComplete,
  onStart,
}: TypewriterTextProps) {
  const [displayedText, setDisplayedText] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    if (!text) {
      setDisplayedText("");
      setIsComplete(true);
      return;
    }

    let i = 0;
    setDisplayedText("");
    setIsComplete(false);
    setHasStarted(false);

    const interval = setInterval(() => {
      if (i < text.length) {
        // Call onStart on first character
        if (i === 0 && !hasStarted) {
          setHasStarted(true);
          onStart?.();
        }
        setDisplayedText(text.slice(0, i + 1));
        i++;
      } else {
        clearInterval(interval);
        setIsComplete(true);
        onComplete?.();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onComplete, onStart]);

  return (
    <span className={cn("", className)}>
      {displayedText}
      {showCursor && !isComplete && (
        <span className="animate-pulse ml-0.5 text-primary">|</span>
      )}
    </span>
  );
}
